import { z } from 'zod';
import { BankAccountPayload, BaseBankAccountPayloadSchema } from './bank-account.payload.entity';

export const SgdSwiftBankAccountPayloadSchema = BaseBankAccountPayloadSchema.merge(
    z.object({
        accountNumber: z.string(),
        bankCode: z.string(),
        branchCode: z.string(),
        swiftCode: z.string().regex(/^[a-zA-Z]{6}(([a-zA-Z0-9]{2})|([a-zA-Z0-9]{5}))$/, {
            message: 'Invalid input. It should start with 6 alphabetic characters followed by either 2 or 5 alphanumeric characters.',
        }),
    }),
);

export class SgdSwiftBankAccountPayload extends BankAccountPayload {
    accountNumber: string;
    bankCode: string;
    branchCode: string;
    swiftCode: string;
}
